import React, { useContext } from 'react'
import TripsContext from '../contexts/TripsContext'


export const useSelectedVehicles = (): any => {
    const { selectedVehicles, setVehicleActive, markerHashMap } = useContext(TripsContext)
    
    const clearAllSelectedVehicles = () => {
        selectedVehicles.forEach((ele:any) => {
            if(ele?.imei){
                const value = markerHashMap.get(ele.imei)
                value?.marker.setMap(null);
            }
        })
        
        selectedVehicles.length = 0
        setVehicleActive([])        
    }

    return { clearAllSelectedVehicles }
}
